// extracted by mini-css-extract-plugin
export var brand = "_4g-9";
export var compact = "_4g-6";
export var extraSmall = "_4g-7";
export var icon = "_4g-0";
export var large = "_4g-4";
export var light = "_4g-1";
export var medium = "_4g-5";
export var outline = "_4g-b";
export var primaryDark = "_4g-a";
export var primaryLight = "_4g-8";
export var primaryModern = "_4g-c";
export var success = "_4g-2";
export var successSolid = "_4g-3";